import React, { useState } from 'react'
import logo from "../../assets/Mega-01.png"
import { HiMenu } from 'react-icons/hi'
import { FaPlus } from 'react-icons/fa6'
import { IoCalendarOutline, IoListOutline, IoPeopleOutline, IoBookOutline, IoChatbubblesOutline, IoSettingsOutline } from 'react-icons/io5'
import { MdFormatListNumbered } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import { setOpen } from '../../redux/slices/sidebarValue'
import CreateAppointment from '../Modals/CreateAppointment'
import CreateProfile from '../Modals/CreateProfile'

// Full iOS top-menu reading order (labels + iOS-equivalent icons). Items without
// a webapp page yet are shown but disabled (no dead links) until those pages exist.
const TOP_MENU = [
    { name: 'Calendar', url: '/calender', match: ['/calender', '/assignProduct'], Icon: IoCalendarOutline },
    { name: 'Overview', url: '/overview', match: ['/overview'], Icon: IoListOutline },
    { name: 'Queue', url: null, match: [], Icon: MdFormatListNumbered },
    { name: 'Directory', url: '/directory', match: ['/directory', '/plus'], Icon: IoPeopleOutline },
    { name: 'Resources', url: null, match: [], Icon: IoBookOutline },
    { name: 'Connect', url: '/communicationLog', match: ['/communicationLog'], Icon: IoChatbubblesOutline },
    { name: 'Account', url: null, match: [], Icon: IoSettingsOutline },
]

// iOS central "+" New menu. enabled items open existing flows; the rest are
// shown but disabled until their flows are built (New Walk-in / New Sale / standalone New Event).
const NEW_MENU = [
    { name: 'New Appointment', action: 'appointment' },
    { name: 'New Walk-in', action: null },
    { name: 'New Event', action: null },
    { name: 'New Sale', action: null },
    { name: 'New Profile', action: 'profile' },
]

const Navbar = () => {
    const dispatch = useDispatch()
    const { open } = useSelector((state) => state?.sidebarValue)
    const navigate = useNavigate()
    const location = useLocation()
    const [newOpen, setNewOpen] = useState(false)
    const [modal, setModal] = useState('') // 'appointment' | 'profile'

    return (
        <div className='flex w-full justify-between items-center'>
            {/* Left: hamburger + "+ New" menu */}
            <div className='flex items-center gap-3 shrink-0'>
                <HiMenu onClick={() => dispatch(setOpen(!open))} className='text-3xl cursor-pointer text-primary' aria-label='Menu' />
                <div className='relative'>
                    <button onClick={() => setNewOpen((v) => !v)} className='flex items-center justify-center rounded-full text-white' style={{ width: 34, height: 34, background: '#2E5B97' }} aria-label='New' title='New'>
                        <FaPlus />
                    </button>
                    {newOpen && (
                        <>
                            <div className='fixed inset-0 z-20' onClick={() => setNewOpen(false)} />
                            <div className='absolute left-0 mt-2 z-30 bg-white rounded-lg shadow-lg border border-gray-200 py-1' style={{ minWidth: 200 }}>
                                {NEW_MENU.map((item) => {
                                    const disabled = !item.action
                                    return (
                                        <button
                                            key={item.name}
                                            disabled={disabled}
                                            onClick={() => { if (item.action) { setModal(item.action); setNewOpen(false); } }}
                                            className='w-full text-left px-4 py-2 font-semibold hover:bg-gray-50'
                                            title={disabled ? 'Coming soon' : undefined}
                                            style={{ fontSize: 14, color: disabled ? '#C7C7CC' : '#1c1c1e', cursor: disabled ? 'default' : 'pointer' }}
                                        >
                                            {item.name}{disabled ? ' (soon)' : ''}
                                        </button>
                                    )
                                })}
                            </div>
                        </>
                    )}
                </div>
            </div>

            {/* Middle: iOS top menu */}
            <nav className='flex items-center gap-7 laptop:gap-5 md:gap-3'>
                {TOP_MENU.map((item) => {
                    const active = item.match.some((m) => location.pathname === m)
                    const disabled = !item.url
                    const color = disabled ? '#C7C7CC' : active ? '#2E5B97' : '#5C5C5C'
                    const Icon = item.Icon
                    return (
                        <button
                            key={item.name}
                            disabled={disabled}
                            onClick={() => item.url && navigate(item.url)}
                            className='font-semibold flex items-center justify-center'
                            title={item.name}
                            style={{
                                fontSize: 16,
                                cursor: disabled ? 'default' : 'pointer',
                                color,
                                borderBottom: active ? '2px solid #2E5B97' : '2px solid transparent',
                                paddingBottom: 4,
                            }}
                        >
                            <Icon style={{ fontSize: 24 }} />
                        </button>
                    )
                })}
            </nav>

            {/* Right: Mega logo (original place) */}
            <img className='w-36 laptop:w-28 md:!w-16 shrink-0' src={logo} alt="logo" />

            {modal === 'appointment' && <CreateAppointment setModal={setModal} />}
            {modal === 'profile' && <CreateProfile setModal={setModal} />}
        </div>
    )
}

export default Navbar
